export default function Rules() {
  const rules = [
    {
      icon: 'ri-questionnaire-line',
      title: 'Ответь на вопросы',
      description: 'Пройди короткий опрос о твоём опыте покупок в Золотом Яблоке'
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Заверши опрос',
      description: 'Ответь на все вопросы честно и получи доступ к награде'
    },
    {
      icon: 'ri-gift-line',
      title: 'Получи 50 000 бьютисов',
      description: 'Забери свою награду сразу после завершения опроса'
    }
  ];

  return (
    <section id="rules" className="py-24 px-4 bg-gradient-to-b from-white to-orange-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Как Получить Награду
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Всего 3 простых шага отделяют тебя от 50 000 бьютисов
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {rules.map((rule, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="bg-gradient-to-br from-amber-400 to-orange-500 w-20 h-20 rounded-2xl flex items-center justify-center mb-6 mx-auto">
                <i className={`${rule.icon} text-4xl text-white`}></i>
              </div>
              
              <div className="text-center">
                <div className="inline-block bg-orange-100 text-orange-600 px-4 py-1 rounded-full text-sm font-semibold mb-4">
                  Шаг {index + 1}
                </div>
                
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  {rule.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {rule.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-amber-500 to-orange-500 rounded-3xl p-8 text-center">
          <i className="ri-time-line text-5xl text-white mb-4"></i>
          <h3 className="text-2xl font-bold text-white mb-3">
            Опрос займёт всего 2-3 минуты
          </h3>
          <p className="text-white/90 text-lg">
            Быстро, просто и с гарантированной наградой!
          </p>
        </div>
      </div>
    </section>
  );
}
